// Premium Black is the starting finish. A deeper display albedo keeps it black
// under gallery lights; the original workbook swatch and catalog hex stay intact.
export const DEFAULT_FINISH = 'xs-5200416';
export const PREMIUM_BLACK_ALBEDO = '#17191c';
export const finishAlbedo = finish => finish.id === DEFAULT_FINISH ? PREMIUM_BLACK_ALBEDO : finish.hex;